import { AppDispatch } from "../store";
import { showConfirmationDialog } from "../slices/confirmationDialogSlice";

/**
 * Shows a confirmation dialog and returns a promise that resolves to true if confirmed, false if cancelled
 * @param dispatch - Redux dispatch function
 * @param message - The message to display in the dialog
 * @param title - Optional title for the dialog (defaults to "Confirm Action")
 * @returns Promise<boolean> - true if confirmed, false if cancelled
 */
export const showConfirmDialog = (
  dispatch: AppDispatch,
  message: string,
  title?: string
): Promise<boolean> => {
  return new Promise((resolve) => {
    dispatch(
      showConfirmationDialog({
        message,
        title,
        resolve,
      })
    );
  });
};
